module.exports = __webpack_public_path__ + "img/emporte-piece-coeur-ex-voto-flamme2.b8ed84b2.jpg";